import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../constants/i18n";
import {
  ONE_O_ONE_C_AI_STATS_FILTER,
  ONE_O_ONE_C_AI_STATUS_FILTER,
  USER_SEARCH_BY_PLACEHOLDERS
} from "../../../../../constants/picker-entries-constants";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Date from "../../../../../core/et3-input/et3-date";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import Et3TextInput from "../../../../../core/et3-input/et3-text-input";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import { getKhattabaAiStore } from "../../../../../stores/khattabat-stores/ai-stores/khattaba-ai-store";
import {
  TEt3PickerMultipleValue,
  TEt3PickerSingleValue
} from "../../../../../TypesNEW";

const AiFilter = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const userID = getKhattabaAiStore().userID.get();

  return (
    <ET3Div
      width={1510}
      height={200}
      alignItems={"space-between"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getKhattabaAiStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={10} bottom={0} left={0} right={0} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getKhattabaAiStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>

      <Et3Margin top={0} bottom={0} left={5} right={5} />

      <ET3Div
        width={300}
        height={0}
        alignItems={"space-between"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("KHATTABA_QUIZ_STATUS")}
          options={ONE_O_ONE_C_AI_STATUS_FILTER}
          value={getKhattabaAiStore().statusFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabaAiStore().setStatusFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={5} bottom={5} left={0} right={0} />

        <Et3Picker
          label={i18n.get("KHATTABA_QUIZ_STATS")}
          options={ONE_O_ONE_C_AI_STATS_FILTER}
          value={getKhattabaAiStore().statsFilter.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabaAiStore().setStatsFilter(value);
          }}
          isMultiple={true}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>

      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={250}
        height={200}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          justifyContent: "center",
          alignItems: "center"
        }}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={false}
          icon={null}
          type={"number"}
          label="User ID"
          placeHolder={USER_SEARCH_BY_PLACEHOLDERS.userId}
          value={!isPositiveNumber(userID) ? i18n.get("SEARCH") : userID}
          onChoose={(value: number) => {
            getKhattabaAiStore().setUserID(value);
          }}
          onBlur={() => {}}
          onEnter={async () => {
            if (isPositiveNumber(userID)) {
              await getKhattabaAiStore().getKhattabaClients();
            }
          }}
          style={{
            minWidth: 250 * unitX,
            minHeight: 45 * unitY,
            width: 250 * unitX,
            height: 45 * unitY
          }}
        />
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={24}
          text={i18n.get("AI_FILTER_USER_ID_DOMINANCE")}
          isSpan={false}
          color={colors.all.black}
          style={{
            textAlign: "left"
          }}
        />
      </ET3Div>

      <Et3Margin top={0} bottom={0} left={100} right={100} />

      <Et3Button
        type="GET"
        isEnabled={true}
        onClick={async () => await getKhattabaAiStore().getKhattabaClients()}
        size="LARGE"
        text="GET"
      />
    </ET3Div>
  );
});

export default AiFilter;
